import { useCallback } from 'react'

import { ChatParticipant } from '@tribeplatform/gql-client/types'

import { useQueryClient } from '../../lib/index.js'
import { getCachedChatParticipantsKey } from '../../utils/keys/messaging.key.js'

interface Args {
  chatId: string
}

export const useAddToCachedParticipants = ({ chatId }: Args) => {
  const queryClient = useQueryClient()
  const cachedChatParticipantsKey = getCachedChatParticipantsKey({
    variables: { chatId },
  })

  const addToCachedParticipants = useCallback(
    (participants: ChatParticipant[]) => {
      queryClient.setQueryData(
        cachedChatParticipantsKey,
        (oldParticipants: Record<string, ChatParticipant>) => {
          const newParticipants = participants.reduce((acc, participant) => {
            acc[participant._id] = participant
            return acc
          }, {})
          return { ...oldParticipants, ...newParticipants }
        },
      )

      queryClient.invalidateQueries(cachedChatParticipantsKey)
    },
    [queryClient, cachedChatParticipantsKey],
  )

  return {
    addToCachedParticipants,
  }
}
